import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../services/context/DataContext'

export const useHMapBoundInfo = (map) => {
  const { showBounds } = useContext(GlobalContext)
  const [,setBounds] = showBounds
  // const [zoom, setZoom] = useState(5)
  const [zoomBounds, setZoomBounds] = useState({})

  useEffect(() => {
    if (map) {
      window.google.maps.event.addListener(map, 'idle', () => {
        // get Bounds
        const b = map.getBounds()
        const bounds = { ne: b.getNorthEast(), sw: b.getSouthWest() }
        setBounds(JSON.stringify(bounds))

        // Set the last visit
        const lastVisit = {
          zoom: map?.getZoom() || 5,
          lat: map?.getCenter()?.lat() || 63.1304,
          lng: map?.getCenter()?.lng() || -96.3468
        }

        // Local Storage
        window.localStorage.setItem('lastBound', JSON.stringify(bounds))
        window.localStorage.setItem('lastVisit', JSON.stringify(lastVisit))

        // set new zoom value if zoom changed
        const newZoom = map?.getZoom()
        // zoom !== newZoom && setZoom(newZoom)
        
        setZoomBounds({
          zoom: zoomBounds?.zoom !== newZoom && newZoom,
          bounds
        })

      })
    }
    // eslint-disable-next-line
  }, [map])

  return {
    // zoom,
    // bounds
    zoomBounds
  }
}
